// extracted by mini-css-extract-plugin
var _1 = "TextSubHeader_actionsContainer__cPQxc";
var _2 = "TextSubHeader_column__exAY-";
var _3 = "TextSubHeader_description__Z228a";
export { _1 as "actionsContainer", _2 as "column", _3 as "description" }
